import {
  catchError,
  pluck,
  switchMap,
  mapTo,
  takeUntil,
  startWith,
} from 'rxjs/operators'
import { of, interval } from 'rxjs'
import { ofType } from 'redux-observable'
import Actions from '../actions'

export const getPayload = (...args) => {
  return src => {
    return src.pipe(ofType(...args), pluck('payload'))
  }
}

export const startPolling = (timeInSeconds, takeUntilParam) => {
  return src =>
    src.pipe(
      switchMap(payload => {
        return interval(timeInSeconds * 1000).pipe(
          takeUntil(takeUntilParam),
          mapTo(payload),
          startWith(payload)
        )
      })
    )
}

export const catchAndDispatchError = catchError(error => {
  console.error(error)
  return of(Actions.createAction(Actions.OPERATION_FAILED, { error }))
})
